<template>
  <div>
    <el-row>
      <el-col>
        <el-button size="medium" @click="addDetail" style="margin-top: 20px">新增</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData" style="margin-top: 20px">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column prop="NAME" label="产品名称"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column label="分成比例">
            <template slot-scope="scope">
              <el-input v-model="scope.row.OP_RATE">
                <template slot="append">%</template>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="费用比例">
            <template slot-scope="scope">
              <el-input v-model="scope.row.FEE_RATE">
                <template slot="append">%</template>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="deleteRecord(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="20">
        <p style="color: red">*删除后请务必点击提交才能生效</p>
      </el-col>
      <el-col :span="4">
        <el-button @click="submitAdd" style="margin-top: 20px;float: right">提交</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { productionDetailFun, addDetailFun } from 'api/production';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      currentPage: 1,
      pageSize: 15,
      totalCount: 0,
      searchForm: {},
      getProductArr: [],
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    // 先取待提交缓存再查询，不依赖异步间隙
    this.getProductArr = JSON.parse(sessionStorage.getItem('productArr'));
    this.queryData();
  },
  methods: {
    queryData() {
      const params = {
        PPL_ID: sessionStorage.getItem('PPL_ID'),
      };
      productionDetailFun(params).then((result) => {
        if (this.getProductArr) {
          const arr = result.concat(this.getProductArr);
          const res = new Map();
          this.tableData = arr.filter((item) => !res.has(item.OP_CODE) && res.set(item.OP_CODE, 1));
        } else {
          this.tableData = result;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData(e - 1);
    },
    addDetail() {
      this.$router.push({ name: 'addProductionDetail' });
    },
    submitAdd() {
      const isEmptyRate = (val) => val === '' || val === null || val === undefined;
      const hasEmpty = this.tableData.some((item) => isEmptyRate(item.OP_RATE) || isEmptyRate(item.FEE_RATE));
      if (hasEmpty) {
        this.$message.show({ text: '数值不能为空', type: 'error' });
        return;
      }
      let submitArr = [];
      submitArr = this.tableData.map((item) => ({ PRODUCT_CODE: item.OP_CODE, OP_RATE: item.OP_RATE, FEE_RATE: item.FEE_RATE }));
      const params = {
        PRODUCT_ARRAY: submitArr,
        PPL_ID: sessionStorage.getItem('PPL_ID'),
      };
      addDetailFun(params).then((result) => {
        // 提交成功后清掉待提交缓存，避免刷新或删除时旧副本“复活”
        sessionStorage.removeItem('productArr');
        this.getProductArr = [];
        this.$message.show({ text: '操作成功', type: 'success' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    deleteRecord(row) {
      const tmpArr = this.tableData.filter((item) => item.OP_CODE !== row.OP_CODE);
      this.tableData = tmpArr;
      // 同步剔除待提交缓存中的副本，避免删除后 queryData 合并时“复活”
      const storedProductArr = sessionStorage.getItem('productArr');
      if (storedProductArr) {
        const leftArr = JSON.parse(storedProductArr).filter((item) => item.OP_CODE !== row.OP_CODE);
        sessionStorage.setItem('productArr', JSON.stringify(leftArr));
        this.getProductArr = leftArr;
      }
      const params = {
        SERVICE_ID: '10053',
        OTYPE: 20,
        PPL_ID: sessionStorage.getItem('PPL_ID'),
        OP_CODE: row.OP_CODE,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '删除成功', type: 'success' });
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/productionProcessing/productionDetail.vue